import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { ScrollToPositions } from '../../shared/menu-bar/menu-bar.component';
import { HomeContainerComponent } from '../home-container/home-container.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-home-bottom-links',
  standalone: true,
  imports: [
    ButtonModule
  ],
  templateUrl: './home-bottom-links.component.html',
  styleUrl: './home-bottom-links.component.scss'
})
export class HomeBottomLinksComponent {


  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }


  navigateAndScrollTo(position: ScrollToPositions) {
    if (this.route.component === HomeContainerComponent) {
      this.scrollTo(position)
    }
    else {
      this.router.navigate(["home"]).then(_ => {
        setTimeout(()=> this.scrollTo(position), 100)
      })
    }
  }

  scrollTo(position: ScrollToPositions) {
    let element = document.getElementById(position)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  openDiscord() {
    window.location.href="https://discord.gg/KHvmMVgwaw"
  }

  goTos() {
    this.router.navigate(["tos"])
  }

  goPrivacy() {
    this.router.navigate(["privacy"])
  }

  goSupportEmail() {
    window.location.href="mailto:support@rorender.com"
  }

  goDocs (){
    this.router.navigate(["docs/quick-start"])
  }
}
